export class IdToNameValueConverter {
	toView(value, list, fieldName, idField) {
		//The binding engine will sometimes pass empty value and list.
		
		if (!value) return;

		if (list) {
			if (idField)
				var item = list.find(a => a[idField] === value);
			else
				var item = list.find(a => a.id === value);
			if (item) {
				if (fieldName)
					return item[fieldName];

				return item.name;
			}
			else return '';
		}
		console.error(`IdValueConverter threw an exception: List not provided for value: ${value}, list = ${list}`)
		return value;
	}
	fromView(value, list, fieldName, idField) {
		//The binding engine will sometimes pass empty value and list.

		if (!value) return;

		if (list) {
			var item = list.find(a => a[fieldName] === value);
			if (item) {
				if (idField)
					return item[idField];

				return item.id;
			}
			else return '';
		}
		console.error(`IdValueConverter threw an exception: List not provided for value: ${value}, list = ${list}`)
		return value;
	}

}